import type { ReportBlock } from '@/lib/types/report'
import { Markdown } from '@/components/chat/Markdown'
import { FillErrorNotice } from '../primitives/FillErrorNotice'

export function NarrativeBlock({ block }: { block: ReportBlock }) {
  const fillError = block.data.fill_error
  if (fillError) return <FillErrorNotice error={String(fillError)} />
  return (
    <div className="report-prose max-w-[70ch]">
      <Markdown>{String(block.data.prose ?? '')}</Markdown>
    </div>
  )
}
